<template>
	<div class="comp">
		<el-dialog :title="row.goodsName+(row.skuValue?' ('+row.skuValue+')':'')" :visible.sync="dialogState" width="700px" :close-on-click-modal="false" :top="'5vh'">
			<div class="tabLine">
				<div class="tab" :class="[active===0?'active':'']" @click="changeTab(0)">全部</div>
				<div class="tab" :class="[active===1?'active':'']" @click="changeTab(1)">已开封</div>
				<div class="tab" :class="[active===2?'active':'']" @click="changeTab(2)">未开封</div>
				<!-- <div class="tab" :class="[active===3?'active':'']" @click="changeTab(3)">待报废</div> -->
			</div>
			<div style="padding-top:10px;max-height: 700px;min-height: 500px;;overflow-y: scroll;">
				<el-table :data="datas.filter(item=>{
					if(active===0) return item;
					if(active===1) return item.status===3;
					if(active===2) return item.status===2;
					if(active===3) return item.status===8;
				})" style="width: 100%" row-key="tableKey">
					<el-table-column label="条码" prop="code">
					</el-table-column>
					<el-table-column label="剩余次数" prop="lastTimes">
					</el-table-column>
					<el-table-column label="状态">
						<template slot-scope="props">
							<div v-if="props.row.status===3">已开封</div>
							<div v-if="props.row.status===2">未开封</div>
							<div v-if="props.row.status===8">待报废</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				dialogState:true,
				active:0,
				datas:[],
				
			}
		},
		props:{
			row:{
				default:''
			},
		},
		watch:{
			dialogState(n){
				if(n==false){
					this.$emit('submit',"close")
				}
			}
		},
		mounted() {
			this.getDatas();
		},
		methods: {
			changeTab(i) {
				this.active=i;
			},
			getDatas(){
				let loading = this.$loading()
				this.$http.get('/api/Goods/ShopStockCodeInfo', {goodsId:this.row.goodsId,skuId:''}).then(res => {
					loading.close();
					if (res.code == 0) {
						this.datas = res.data
					}
				})
			},
		}
	}
</script>
<style lang="scss" scoped>
	.comp {
		.tabLine{
			width: 300px;
			display: flex;
			justify-content: space-around;
			.tab{
				font-size: 16px;
				text-align: center;
				cursor: pointer;
				padding:0 5px 8px;
				&.active{
					color:rgb(253, 208, 0);
					border-bottom:2px solid rgb(253, 208, 0);
				}
			}
		}
	}
</style>
